<script>
import Layout from "../../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from '@/components/Page-header';
import appConfig from "../../../../../app.config";
import Switches from "vue-switches";

import UserSSOAPI from "@/services/sso/users/userSSOAPI"
import UserAPI from "@/services/user/userAPI"
import RoleAPI from "@/services/role/roleAPI"
import PermissionsAPI from "@/services/permissions/permissionsAPI"

import Swal from "sweetalert2";

/**
 * Form elements component
 */
export default {
  page: {
    title: "Editar permisos de usuario",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    Switches,
    PageHeader,
  },
  data() {
    return {
      title: "Editar permisos de usuario",
      items: [
        {
          text: "",
          href: "/",
        },
        {
          text: "",
          href: "/",
        },
        {
          text: "",
          active: true,
        },
      ],

      user: null,

      exist: false,
      loading: true,

      permissions: [],
      userPermissions: [false, false, false, false, false, false],

      roles: [],

    };
  },
  methods: {

    goBack() {
      this.$router.go(-1);
    },

    goRegisterPage() {
      this.$router.push({
        name: "registro-rol",
        params: {
          id: this.$route.params.id,
        },
      });
    },

    getUser() {
      this.getRoles()
      UserAPI.getSSO(this.$route.params.id)
        .then(response => {

          if (response.length > 0) {
            this.exist = true
          }

          UserSSOAPI.get(this.$route.params.id)
            .then(resp => {

              const data = resp.data

              this.user = {
                id: data.id,
                name: data.name,
                email: data.email,
                sst_id: response.length > 0 ? response[0].id : null,
                role_id: response.length > 0 ? response[0].rol_id : null,
                role: this.getRoleName(response.length > 0 ? response[0].rol_id : null),
                permissions: response.length > 0 ? response[0].permissions : null
              }

              const permissions = this.user.permissions.map(permission => {
                return permission.id
              })

              this.userPermissions = this.userPermissions.map((item, index) => {
                return permissions.includes(index + 1)
              })

              PermissionsAPI.getAll()
                .then(resp => {

                  const perm = resp.Permissions.data
                  this.permissions = perm
                  this.loading = false

                })
                .catch(error => {
                  console.log(error)
                  this.loading = false

                })

            })
            .catch(error => {
              console.log(error)
            })

        })
        .catch(error => {
          console.log(error)
        })

    },

    getRoles() {
      RoleAPI.getAll()
        .then(response => {

          let roles = response.Rol.data

          roles = roles.map(role => {
            return {
              id: role.id,
              name: role.name.replace('_', ' '),
              status: role.status,
            }
          })

          roles = roles.map(role => {
            return {
              id: role.id,
              name: role.name.replace('ñia', 'ñía'),
              status: role.status,
            }
          })

          roles = roles.map(role => {
            return {
              id: role.id,
              name: role.name.replace('ion', 'ión'),
              status: role.status,
            }
          })

          this.roles = roles
        })
        .catch(error => {
          console.log(error)
        })
    },

    getRoleName(id) {
      return id ? this.roles.find(item => item.id == id).name : '-'
    },

    save() {

      let perm = this.userPermissions.map((item, index) => {
        return {
          permission_id: index + 1,
          status: item,
        }
      })

      perm = perm.filter(item => item.status)

      perm = perm.map(item => {
        return {
          permission_id: item.permission_id,
        }
      })

      if (perm.length > 0) {

        let promises = []

        for (let index = 1; index <= this.userPermissions.length; index++) {
          promises.push(UserAPI.removePermission(this.user.sst_id, index))
        }

        Promise.all(promises)
          .then(response => {

            if (this.exist) {

              UserAPI.giveSeveralPermissions(this.user.sst_id, perm)
                .then(response => {

                  if (response.message === "Permisos agregados con exito") {

                    Swal.fire({
                      title: "¡Éxito!",
                      text: "¡Permisos actualizados con exito!",
                      type: "success",
                      icon: "success",
                      confirmButtonClass: "btn btn-confirm mt-2",
                    });
                    this.goBack()

                  } else {
                    Swal.fire({
                      title: "¡Error!",
                      text: "¡Hubo un error en la actualización de permisos!",
                      type: "warning",
                      icon: "warning",
                      confirmButtonClass: "btn btn-confirm mt-2",
                    });
                  }

                })
                .catch(error => {
                  console.log(error)

                  Swal.fire({
                    title: "¡Error!",
                    text: "¡Hubo un error en la actualización de permisos!",
                    type: "warning",
                    icon: "warning",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                })

            }

          })
          .catch(error => {
            console.log(error)
          })

      } else {

        Swal.fire({
          title: "Error!",
          text: "¡Debes seleccionar al menos un permiso!",
          type: "warning",
          icon: "warning",
          confirmButtonClass: "btn btn-confirm mt-2",
        });

      }

    }

  },
  mounted() {
    this.getRoles()
    this.getUser()
  },

};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-6">
              </div>

              <div class="col-6 text-right">
                <div @click="goBack" class="btn btn-secondary m-l-5 ml-1" id="tooltip">
                  <i class="fas fa-arrow-left"></i>
                </div>
                <b-tooltip target="tooltip" placement="left">Volver</b-tooltip>
              </div>
            </div>

            <form calss="form-group" @submit.prevent="save">
              <div v-if="!loading">
                <div class="form-row pt-1">
                  <h5>
                    Datos del usuario
                  </h5>
                </div>
                <div class="form-row pt-1">

                  <b-form-group class="col-sm-12 col-md-6 px-2" label="Usuario" label-for="name">
                    <b-form-input type="text" disabled id="appointment_date" v-model="user.name">
                    </b-form-input>
                  </b-form-group>

                  <b-form-group class="col-sm-12 col-md-6 px-2" label="Rol" label-for="role">
                    <b-form-input type="text" disabled id="appointment_date" v-model="user.role">
                    </b-form-input>
                  </b-form-group>

                </div>

                <hr />

                <div class="form-row pt-1">
                  <h5>
                    Permisos
                  </h5>
                </div>

                <div class="form-row pt-1">

                  <b-form-group v-for="(item, index) in permissions" :key="item.id"
                    class="col-xs-4 col-sm-3 col-md-2 px-2" :label="item.name" label-for="permissions">
                    <switches v-model="userPermissions[index]" type-bold="true" color="primary" class="mb-0 py-2">
                    </switches>
                  </b-form-group>

                </div>

                <div class="form-group text-right m-b-0">
                  <button type="submit" class="btn btn-primary">
                    Guardar
                  </button>
                  <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>
              </div>

              <div v-else>
                <div class="text-center">
                  <b-spinner variant="primary" label="Loading..."></b-spinner>
                </div>
              </div>

            </form>

          </div>
        </div>
      </div>
    </div>


  </Layout>
</template>
